import React from "react";
import "./shipmentInformation.scss";
import AccountDetailsBoxTitle from "../../atoms/AccountDetailsBoxTitle/AccountDetailsBoxTitle";
import ListItem from "../../../ds/ListItem/ListItem";
import CopyToClipBoard from "../../atoms/CopyToClipBoard/CopyToClipBoard";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../../pages/Landings/common/returnText";
import { useShippingAddresses } from "../../../hooks/shippingAddresses";

const ShipmentInformation = ({ country }) => {
  const countrySplit = country?.split(" ")[0];
  // const { data: userData, isLoading, isError } = useUserData();
  const userData = JSON.parse(localStorage.getItem("user"));
  const { shippingAddress } = useShippingAddresses();
  const shippingAddressfiltered = shippingAddress?.find(
    (dict) => dict.country === countrySplit
  );

  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  return (
    <div className="shipment-information">
      <AccountDetailsBoxTitle
        main={Returntext(contentManagementData, "ShipmentInformation", lang)}
        sub={Returntext(contentManagementData, "ShipmentInformationSub", lang)}
      />

      {userData.customerType === "PERSONAL" ? (
        <ListItem
          hasBorder={false}
          hasPadding={false}
          hasIcon={false}
          headline={Returntext(contentManagementData, "name", lang)}
          description={`${userData?.first_name} ${userData?.last_name}`}
          buttons={
            <CopyToClipBoard
              textToCopy={`${userData?.first_name} ${userData?.last_name}`}
            />
          }
        />
      ) : (
        <ListItem
          hasBorder={false}
          hasPadding={false}
          hasIcon={false}
          headline={Returntext(contentManagementData, "name", lang)}
          description={`${userData?.company_info}`}
          buttons={<CopyToClipBoard textToCopy={`${userData?.company_info}`} />}
        />
      )}

      <div className="break" />

      {countrySplit === "USA" ? (
        <ListItem
          hasBorder={false}
          hasPadding={false}
          hasIcon={false}
          headline={Returntext(contentManagementData, "Address", lang)}
          description={`${
            shippingAddressfiltered?.street
          } UNIT ${userData.room_number.toUpperCase()}`}
          buttons={
            <CopyToClipBoard
              textToCopy={`${
                shippingAddressfiltered?.street
              } UNIT ${userData.room_number.toUpperCase()}`}
            />
          }
        />
      ) : (
        <ListItem
          hasBorder={false}
          hasPadding={false}
          hasIcon={false}
          headline={Returntext(contentManagementData, "Address", lang)}
          description={
            country === "China Cargo"
              ? `${Returntext(
                  contentManagementData,
                  "address_china_value",
                  lang
                ).replaceAll(
                  "room",
                  `LND ${userData.room_number.toUpperCase()}`
                )}`
              : `${Returntext(
                  contentManagementData,
                  "address_china_value",
                  lang
                ).replaceAll("room", userData.room_number.toUpperCase())}`
          }
          buttons={
            <CopyToClipBoard
              textToCopy={
                country === "China Cargo"
                  ? `${Returntext(
                      contentManagementData,
                      "address_china_value",
                      lang
                    ).replaceAll(
                      "room",
                      `LND ${userData.room_number.toUpperCase()}`
                    )}`
                  : `${Returntext(
                      contentManagementData,
                      "address_china_value",
                      lang
                    ).replaceAll("room", userData.room_number.toUpperCase())}`
              }
            />
          }
        />
      )}

      {countrySplit === "USA" ? null : (
        <>
          <div className="break" />
          <ListItem
            hasBorder={false}
            hasPadding={false}
            hasIcon={false}
            headline={Returntext(contentManagementData, "province", lang)}
            description={Returntext(
              contentManagementData,
              "province_china_value",
              lang
            )}
            buttons={
              <CopyToClipBoard
                textToCopy={Returntext(
                  contentManagementData,
                  "province_china_value",
                  lang
                )}
              />
            }
          />
        </>
      )}

      {countrySplit === "USA" ? null : (
        <>
          <div className="break" />
          <ListItem
            hasBorder={false}
            hasPadding={false}
            hasIcon={false}
            headline={Returntext(contentManagementData, "district", lang)}
            description={Returntext(
              contentManagementData,
              "district_china_value",
              lang
            )}
            buttons={
              <CopyToClipBoard
                textToCopy={Returntext(
                  contentManagementData,
                  "district_china_value",
                  lang
                )}
              />
            }
          />
        </>
      )}

      {countrySplit === "USA" ? null : (
        <>
          <div className="break" />
          <ListItem
            hasBorder={false}
            hasPadding={false}
            hasIcon={false}
            headline={Returntext(contentManagementData, "street_china", lang)}
            description={Returntext(
              contentManagementData,
              "street_china_value",
              lang
            )}
            buttons={
              <CopyToClipBoard
                textToCopy={Returntext(
                  contentManagementData,
                  "street_china_value",
                  lang
                )}
              />
            }
          />
        </>
      )}

      <div className="break" />
      <ListItem
        hasBorder={false}
        hasPadding={false}
        hasIcon={false}
        headline={Returntext(contentManagementData, "City", lang)}
        description={shippingAddressfiltered?.city}
        buttons={<CopyToClipBoard textToCopy={shippingAddressfiltered?.city} />}
      />
      <div className="break" />

      <ListItem
        hasBorder={false}
        hasPadding={false}
        hasIcon={false}
        headline={Returntext(contentManagementData, "Zip", lang)}
        description={shippingAddressfiltered?.zipCode}
        buttons={
          <CopyToClipBoard textToCopy={shippingAddressfiltered?.zipCode} />
        }
      />
      <div className="break" />
      {countrySplit === "USA" ? (
        <>
          <ListItem
            hasBorder={false}
            hasPadding={false}
            hasIcon={false}
            headline={Returntext(contentManagementData, "State", lang)}
            description={shippingAddressfiltered?.state}
            buttons={
              <CopyToClipBoard textToCopy={shippingAddressfiltered?.state} />
            }
          />
          <div className="break" />
        </>
      ) : null}

      <ListItem
        hasBorder={false}
        hasPadding={false}
        hasIcon={false}
        headline={Returntext(contentManagementData, "Country", lang)}
        description={shippingAddressfiltered?.country}
        buttons={
          <CopyToClipBoard textToCopy={shippingAddressfiltered?.country} />
        }
      />
      <div className="break" />

      <ListItem
        hasBorder={false}
        hasPadding={false}
        hasIcon={false}
        headline={Returntext(contentManagementData, "Tel", lang)}
        description={shippingAddressfiltered?.tel}
        buttons={<CopyToClipBoard textToCopy={shippingAddressfiltered?.tel} />}
      />
    </div>
  );
};

export default ShipmentInformation;
